"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const ListView_1 = __importDefault(require("@/components/data/ListView"));
const plugin_1 = require("@/plugin");
const mainData_1 = __importDefault(require("./mainData"));
const mainData_2 = __importDefault(require("../../application/mainData"));
exports.default = (0, vue_1.defineComponent)({
    name: 'AssignRule',
    components: {
        ListView: ListView_1.default
    },
    data() {
        return {
            mainData: mainData_1.default,
            litigationApplication: mainData_2.default,
            litigationApplicationOption: {
                edit: {
                    modal: {
                        formatName: function () { return '发起诉讼审批'; },
                        optionProps: { width: 1080 }
                    }
                }
            }
        };
    },
    computed: {
        width() {
            return this.getWidth();
        },
        choiceList() {
            return this.mainData.$module.choice.getList();
        },
        listOption() {
            return {
                table: {
                    optionProps: {
                        bordered: true,
                        scroll: {
                            x: this.getWidth()
                        }
                    }
                },
                search: {},
                searchMenu: [
                    {
                        prop: 'setSearch',
                        name: '查询',
                        type: 'primary'
                    },
                    {
                        prop: 'resetSearch',
                        name: '重置',
                        type: 'default'
                    },
                    {
                        prop: 'build-application',
                        name: '发起诉讼审批',
                        type: 'primary',
                        disabled: this.choiceList.length === 0
                    },
                    {
                        prop: 'export',
                        name: '导出',
                        type: 'primary'
                    },
                ],
            };
        }
    },
    mounted() {
        this.mainData.$loadData(true);
    },
    beforeUnmount() {
        mainData_1.default.$reset();
    },
    methods: {
        getWidth() {
            return plugin_1.reactiveLayout.data.main.width - 16 * 2;
        },
        onMenu(from, prop) {
            if (from === 'search') {
                if (prop === 'build-application') {
                    this.$refs['application-view'].openEdit('build', '新增', {
                        contractTotalNum: this.choiceList.length,
                        overdueRecord: this.choiceList
                    });
                }
            }
        }
    }
});
